import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import ManageEmployeesSection from './ManageEmployeesSection';
import ManageClientsSection from './ManageClientsSection';

const SIDEBAR_BG = '#1a1d29';
const SIDEBAR_ACTIVE = '#2b2f42';

const NAV_ITEMS = [
  { key: 'employees', label: 'Manage Employees', icon: 'fa-user-tie' },
  { key: 'clients', label: 'Manage Clients', icon: 'fa-building' },
  { key: 'finance', label: 'Finance', icon: 'fa-wallet', disabled: true },
  { key: 'sales', label: 'Sales', icon: 'fa-chart-line', disabled: true },
];

const ManageEmployeesClients = () => {
  const navigate = useNavigate();
  const { section } = useParams();
  const activeSection = section === 'clients' ? 'clients' : 'employees';
  const activeItem = NAV_ITEMS.find(item => item.key === activeSection);

  return (
    <>
      <Navbar />
      <div style={{ display: 'flex', minHeight: 'calc(100vh - 56px)', alignItems: 'stretch' }}>
        {/* Dark theme sidebar — scoped to this page only */}
        <div
          style={{
            width: 250,
            flexShrink: 0,
            backgroundColor: SIDEBAR_BG,
            color: '#c8ccd8',
            paddingTop: '1.5rem',
          }}
        >
          <div className="px-3 mb-4 d-flex align-items-center">
            <i className="fas fa-users-cog me-2" style={{ fontSize: '1.4rem', color: '#4f8bff' }}></i>
            <span className="fw-bold text-white">Employees &amp; Clients</span>
          </div>
          <nav>
            {NAV_ITEMS.map(item => {
              const isActive = activeSection === item.key;
              return (
                <div
                  key={item.key}
                  onClick={() => {
                    if (item.disabled) return;
                    navigate(`/admin/employees-clients/${item.key}`);
                  }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '0.85rem 1.25rem',
                    cursor: item.disabled ? 'not-allowed' : 'pointer',
                    backgroundColor: isActive ? SIDEBAR_ACTIVE : 'transparent',
                    borderLeft: isActive ? '3px solid #4f8bff' : '3px solid transparent',
                    color: item.disabled ? '#5c6070' : (isActive ? '#ffffff' : '#c8ccd8'),
                    opacity: item.disabled ? 0.6 : 1,
                    transition: 'background-color 0.15s ease',
                  }}
                >
                  <i className={`fas ${item.icon} me-3`} style={{ width: 18, textAlign: 'center' }}></i>
                  <span>{item.label}</span>
                  {item.disabled && (
                    <span className="badge bg-secondary ms-auto" style={{ fontSize: '0.65rem' }}>
                      Coming Soon
                    </span>
                  )}
                </div>
              );
            })}
          </nav>
        </div>

        {/* Content area */}
        <div style={{ flex: 1, backgroundColor: '#f4f6f9', padding: '2rem' }}>
          <h2 className="fw-bold mb-1">
            <i className="fas fa-id-badge me-2 text-primary"></i>
            Employees and Clients Dashboard
          </h2>
          <h5 className="text-muted mb-4">
            <i className={`fas ${activeItem.icon} me-2`}></i>
            {activeItem.label}
          </h5>

          {activeSection === 'employees' && <ManageEmployeesSection />}
          {activeSection === 'clients' && <ManageClientsSection />}
        </div>
      </div>
    </>
  );
};

export default ManageEmployeesClients;
